var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "rp-file has-name is-fullwidth is-small" }, [
      _c("label", { staticClass: "rp-file-label" }, [
        _c("input", {
          ref: "files",
          staticClass: "rp-file-input",
          attrs: { type: "file", placeholder: _vm.inputData.placeholder },
          on: {
            change: function($event) {
              return _vm.updateValue($event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "rp-file-cta" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("span", { staticClass: "rp-file-label" }, [
            _c("span", [
              _vm._v("\n          " + _vm._s(_vm.t.chooseFile) + "\n          ")
            ])
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "rp-file-name" }, [
          _vm._v(
            "\n        " + _vm._s(_vm.filenames || _vm.t.noFile) + "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _vm.status === true && _vm.errorStatus === ""
      ? _c("div", { staticClass: "validation-text" }, [
          _vm._v("\n    " + _vm._s(_vm.t.pleaseChooseFile) + "\n  ")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.status === true && _vm.errorStatus === "pleaseUploadAllowedFileType"
      ? _c("div", { staticClass: "validation-text" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.t.pleaseUploadAllowedFileType) +
              ": " +
              _vm._s(_vm.formData.type) +
              "\n  "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.status === true && _vm.errorStatus === "pleaseUploadAllowedFileSize"
      ? _c("div", { staticClass: "validation-text" }, [
          _vm._v(
            "\n    " +
              _vm._s(_vm.t.pleaseUploadAllowedFileSize) +
              " " +
              _vm._s(_vm.bytesToSize(_vm.formData.size)) +
              "\n  "
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "rp-file-icon" }, [
      _c("i", { staticClass: "fa fa-upload" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-400ceac3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-400ceac3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/form/FileInput.vue
// module id = null
// module chunks = 